import { render, staticRenderFns } from "./Vistion.vue?vue&type=template&id=1580d028&"
import script from "./Vistion.vue?vue&type=script&lang=js&"
export * from "./Vistion.vue?vue&type=script&lang=js&"
import style0 from "./Vistion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports